import React, { useMemo } from 'react';
import { useZunelo } from '../../context/ZuneloContext';
import { GITHUB_AXES, sortRecentAttentionItems } from '../../domain/filtering';
import { defaultAxisFilterState, filterByAxes } from '../../domain/multiAxisFiltering';
import { FilterButton } from '../../ui/common/FilterButton';
import { GitHubCard } from './GitHubCard';
import { SourceFeedState } from '../sources/SourceFeedState';
import { SourceGate } from '../sources/SourceGate';

export const GitHubView: React.FC = () => {
  const {
    items,
    activeAxisFilters,
    setActiveAxisFilters,
    selectedId,
    loadingSources,
    errors,
    retry,
  } = useZunelo();

  const sourceItems = useMemo(
    () => sortRecentAttentionItems(items.filter((i) => i.source === 'github')),
    [items],
  );
  const currentFilters = activeAxisFilters['github'] || defaultAxisFilterState(GITHUB_AXES);
  const isLoading = loadingSources.github && sourceItems.length === 0;

  const filteredItems = useMemo(
    () => filterByAxes(sourceItems, GITHUB_AXES, currentFilters),
    [sourceItems, currentFilters],
  );

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
      }}
    >
      <SourceGate
        source="github"
        error={errors.github}
        isLoading={isLoading}
        totalCount={sourceItems.length}
        isRetrying={loadingSources.github}
        onRetry={() => retry('github')}
      >
        <FilterButton
          axes={GITHUB_AXES}
          items={sourceItems}
          value={currentFilters}
          onChange={(next) => setActiveAxisFilters('github', next)}
        />

        <SourceFeedState
          source="github"
          error={errors.github}
          isLoading={isLoading}
          isRetrying={loadingSources.github}
          onRetry={() => retry('github')}
          totalCount={sourceItems.length}
          visibleCount={filteredItems.length}
          onShowAll={() => setActiveAxisFilters('github', defaultAxisFilterState(GITHUB_AXES))}
        >
          {filteredItems.map((item) => (
            <GitHubCard key={item.id} item={item} isSelected={selectedId === item.id} />
          ))}
        </SourceFeedState>
      </SourceGate>
    </div>
  );
};
